export default {
  cn: { code: 'cn', name: 'China', dialCode: 86, phoneFormat: '131 2345 6789' },
  us: { 'code': 'us', 'name': 'America', 'dialCode': 1, 'phoneFormat': '(201) 555-0123' },
  au: {
    code: 'au',
    name: 'Australia',
    dialCode: 61,
    phoneFormat: '0412 345 678'
  },
  jp: { code: 'jp', name: 'Japan', dialCode: 81, phoneFormat: '090-1234-5678' },
  tw: { code: 'tw', name: 'Taiwan', dialCode: 886, phoneFormat: '0912 345 678' },
  mo: { code: 'mo', name: 'Aomen', dialCode: 853, phoneFormat: '6612 3456' },
  hk: { code: 'hk', name: 'Hong Kong', dialCode: 852, phoneFormat: '5123 4567' },
  kr: { code: 'kr', name: 'Korea', dialCode: 82, phoneFormat: '010-0000-0000' },
  ca: {
    code: 'ca',
    name: 'Canada',
    dialCode: 1,
    phoneFormat: '(204) 234-5678'
  },
  gg: { code: 'gg', name: 'Britain', dialCode: 44, phoneFormat: '07781 123456' },
  fr: { code: 'fr', name: 'France', dialCode: 33, phoneFormat: '06 12 34 56 78' },
  de: { code: 'de', name: 'Germany', dialCode: 49, phoneFormat: '01512 3456789' },
  it: { code: 'it', name: 'Italy', dialCode: 39, phoneFormat: '312 345 6789' },
  in: { code: 'in', name: 'India', dialCode: 91, phoneFormat: '099876 54321' },
  ru: {
    code: 'ru',
    name: 'Russia',
    dialCode: 7,
    phoneFormat: '8 (912) 345-67-89'
  },
  pt: { code: 'pt', name: 'Portuguesa', dialCode: 351, phoneFormat: '912 345 678' },
  ph: {
    code: 'ph',
    name: 'Philippines',
    dialCode: 63,
    phoneFormat: '0905 123 4567'
  },
  pk: {
    code: 'pk',
    name: 'Pakistan',
    dialCode: 92,
    phoneFormat: '0301 2345678'
  },
  no: { code: 'no', name: 'Norway', dialCode: 47, phoneFormat: '406 12 345' },
  nz: { code: 'nz', name: 'New Zealand ', dialCode: 64, phoneFormat: '021 123 4567' },
  nl: { code: 'nl', name: 'Holland', dialCode: 31, phoneFormat: '06 12345678' },
  mn: { code: 'mn', name: 'Mongolia', dialCode: 976, phoneFormat: '8812 3456' },
  mx: {
    code: 'mx',
    name: 'Mexico',
    dialCode: 52,
    phoneFormat: '044 222 123 4567'
  },
  my: {
    code: 'my',
    name: 'Malaysia',
    dialCode: 60,
    phoneFormat: '012-345 6789'
  },
  lu: { code: 'lu', name: 'Luxembourg', dialCode: 352, phoneFormat: '628 123 456' },
  lt: {
    code: 'lt',
    name: 'Lithuania',
    dialCode: 370,
    phoneFormat: '(8-612) 34567'
  },
  la: {
    code: 'la',
    name: 'Laos',
    dialCode: 856,
    phoneFormat: '020 23 123 456'
  },
  ie: {
    code: 'ie',
    name: 'Ireland',
    dialCode: 353,
    phoneFormat: '085 012 3456'
  },
  il: {
    code: 'il',
    name: 'Israel',
    dialCode: 972,
    phoneFormat: '050-123-4567'
  },
  id: {
    code: 'id',
    name: 'Indonesia',
    dialCode: 62,
    phoneFormat: '0812-345-678'
  },
  gr: { code: 'gr', name: 'Greece', dialCode: 30, phoneFormat: '691 234 5678' },
  fi: { code: 'fi', name: 'Finland', dialCode: 358, phoneFormat: '041 2345678' },
  ko: { code: 'ko', name: 'south korea', dialCode: 82, phoneFormat: '' },
  kh: { code: 'kh', name: 'Cambodia', dialCode: 855, phoneFormat: '091 234 567' },
  br: { code: 'br', name: 'Baxi', dialCode: 55, phoneFormat: '(11) 96123-4567' }
}
